<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M10.0008 10.6008C10.0008 10.9321 10.2695 11.2008 10.6008 11.2008C10.9321 11.2008 11.2008 10.9321 11.2008 10.6008V9.40078C11.2008 9.0695 10.9321 8.80078 10.6008 8.80078C10.2695 8.80078 10.0008 9.0695 10.0008 9.40078V10.6008Z"
            fill="currentColor"
        />
        <path
            d="M5.40078 11.2008C5.0695 11.2008 4.80078 10.9321 4.80078 10.6008V7.40078C4.80078 7.0695 5.0695 6.80078 5.40078 6.80078C5.73206 6.80078 6.00078 7.0695 6.00078 7.40078V10.6008C6.00078 10.9321 5.73206 11.2008 5.40078 11.2008Z"
            fill="currentColor"
        />
        <path
            d="M7.40078 10.6008C7.40078 10.9321 7.6695 11.2008 8.00078 11.2008C8.33206 11.2008 8.60078 10.9321 8.60078 10.6008V5.40078C8.60078 5.0695 8.33206 4.80078 8.00078 4.80078C7.6695 4.80078 7.40078 5.0695 7.40078 5.40078V10.6008Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.80078 1.80078C3.14393 1.80078 1.80078 3.14393 1.80078 4.80078V11.2008C1.80078 12.8576 3.14393 14.2008 4.80078 14.2008H11.2008C12.8576 14.2008 14.2008 12.8576 14.2008 11.2008V4.80078C14.2008 3.14393 12.8576 1.80078 11.2008 1.80078H4.80078ZM3.00078 4.80078C3.00078 3.80667 3.80667 3.00078 4.80078 3.00078H11.2008C12.1949 3.00078 13.0008 3.80667 13.0008 4.80078V11.2008C13.0008 12.1949 12.1949 13.0008 11.2008 13.0008H4.80078C3.80667 13.0008 3.00078 12.1949 3.00078 11.2008V4.80078Z"
            fill="currentColor"
        />
    </svg>
</template>
